// Catalogue des sections d'un livrable.
//
// Une section est une brique de restitution : une clé stable (stockée en base),
// un libellé, et une phrase qui dit ce qu'elle montre. Le CONTENU est assemblé
// à la lecture depuis la base réelle — le livrable ne fige rien.
import type { SectionKey } from '../api/types';

export interface SectionDef {
  key: SectionKey;
  label: string;
  hint: string;
}

/** Ordre de lecture d'une restitution : on situe, on note, on prouve, on incarne. */
export const SECTION_CATALOG: SectionDef[] = [
  { key: 'synthese', label: 'Synthèse', hint: 'Volume de preuve et santé de la recherche en un coup d’œil.' },
  { key: 'adoption', label: 'Adoption Score', hint: 'La note globale, les piliers et leur tendance.' },
  { key: 'insights', label: 'Insights', hint: 'Les conclusions, avec le nombre de faits qui les étayent.' },
  { key: 'personas', label: 'Personas', hint: 'Les profils auxquels les résultats se rattachent.' },
  { key: 'triangulation', label: 'Triangulation', hint: 'Le croisement terrain / données mesurées.' },
  { key: 'tests', label: 'Tests utilisateurs', hint: 'Taux de réussite par protocole.' },
  { key: 'decisions', label: 'Décisions', hint: 'Les hypothèses tranchées, avec l’avant/après et la raison.' },
];

const BY_KEY = new Map(SECTION_CATALOG.map((s) => [s.key, s]));

export function sectionLabel(key: SectionKey): string {
  return BY_KEY.get(key)?.label ?? key;
}

/** Filtre + ordonne une sélection selon le catalogue, en écartant les clés
 *  inconnues (une section retirée du produit ne doit pas casser un vieux livrable). */
export function orderedSections(selected: SectionKey[]): SectionDef[] {
  return SECTION_CATALOG.filter((s) => selected.includes(s.key));
}
